import React from "react";

import AmenityCell from "./Cells/AmenityCell";
import IdCell from "./Cells/IdCell";
import NameCell from "./Cells/NameCell";
import TimeslotCell from "./Cells/TimeslotCell";
import { BOOKINGS_VIEWS } from "../../Bookings";
import CustomFormValueCell from "../../../../Components/Table/Cells/CustomFormValueCell";
import StatusCell from "./Cells/StatusCell";
import BookingActionsCell from "./Cells/BookingActionsCell";

export const defaultColumns = {
    'reference': {
        key: 'reference',
        name: 'Reference',
        selector: row => (<IdCell key="id-cell" row={row} />)
    },
    'timeslot': {
        key: 'timeslot',
        name: 'Timeslot',
        selector: row => (<TimeslotCell key="timeslot-cell" row={row} />),
    },
    'name': {
        key: 'name',
        name: 'Name',
        selector: row => (<NameCell key="name-cell" row={row} />),
    },
    'amenity': {
        key: 'amenity',
        name: 'Amenity',
        selector: row => (<AmenityCell key="amenity-cell" row={row} />),
    },
};

/**
 * @param scope
 * @param view
 * @param {object} selectedCategoryData
 * @param {boolean} signInEnabled
 * @returns {{reference: {name: string, selector: function(*): *, key: string}, amenity: {name: string, selector: function(*): *, key: string}, timeslot: {name: string, selector: function(*): *, key: string}, name: {name: string, selector: function(*): *, key: string}}|*[]|({name: string, selector: function(*): *, key: string} | {name: string, selector: function(*): *, key: string} | {name: string, selector: function(*): *, key: string} | {name: string, selector: function(*): *, key: string})[]}
 */
export const getColumns = (scope, view, selectedCategoryData, signInEnabled = false) => {

    let columns = (selectedCategoryData)
        ? getBookingsColumnsForCategory(selectedCategoryData, view)
        : Object.values(getBookingsColumns(view));

    if (signInEnabled) {
        columns.push({
            key: 'status',
            name: 'Status',
            selector: row => (<StatusCell key="booking-status-cell" row={row}/>),
        });
    }

    columns.push({
        key: 'actions',
        name: 'Actions',
        selector: row => (<BookingActionsCell key="booking-actions-cell" row={row}/>),
        right: true,
    });

    return columns
}

export const getBookingsColumns = (view) => {

    let columns = {...defaultColumns};

    // Don't show the 'name' column in the my bookings view
    // ...it only shows user's own bookings
    if (view === BOOKINGS_VIEWS.MY_BOOKINGS) {
        delete (columns['name']);
    }

    return columns;
}

export const getBookingsColumnsForCategory = (categoryData, view) => {
    const baseColumns = getBookingsColumns(view);

    if (!categoryData || !categoryData.columns) {
        return Object.values(baseColumns);
    }

    let columns = [];

    categoryData.columns.map(categoryColumn => {
        let [columnType, columnId] = categoryColumn.split('|');

        if (columnType === 'default' && baseColumns.hasOwnProperty(columnId)) {
            columns.push(baseColumns[columnId]);
        } else if (columnType === 'custom') {
            if (!categoryData.custom_form || !categoryData.custom_form.fields) {
                return;
            }

            let columnFormField = categoryData.custom_form.fields.find((field) => field.id === columnId);

            columns.push({
                key: `custom|customFormField.${columnId}`,
                name: columnFormField?.label ?? '',
                selector: row => (
                    <CustomFormValueCell
                        row={row}
                        formField={columnFormField}
                    />),
            });
        }
    });

    return columns;
}
